import React from "react";
import { Reveal } from "@/components/Reveal";
import { IMAGES, SITE } from "@/data/site";
import useSeo from "@/lib/useSeo";

export default function About() {
  useSeo({ title: "About Us", description: "VacanzaGo — Haridwar's pilgrimage and Himalayan tour operator since 2016. Our story, philosophy and how we work." });
  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="eyebrow">Since {SITE.since} · {SITE.city}</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">We know India intimately</h1>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <Reveal className="img-zoom rounded-md overflow-hidden aspect-[4/3]">
            <img src={IMAGES.kedarnath} alt="Kedarnath" className="h-full w-full object-cover" loading="lazy" />
          </Reveal>
          <Reveal delay={100} className="space-y-4 text-[#553204] text-lg leading-relaxed">
            <p>VacanzaGo began in Haridwar in {SITE.since} — the gateway to the Char Dham and one of India's seven sacred cities. We started with pilgrimage, and grew into the Himalaya, Kashmir, Ladakh, Himachal, Goa and beyond.</p>
            <p>We don't sell packages. We craft memories. That means verified hotels, transparent itemised pricing, full ground support and a team that takes ownership of every operational detail — permits, darshan arrangements, transfers and timing.</p>
            <p>Today we also handle events — from an intimate puja to a full destination wedding — with the same care. You don't have to worry about anything once we take over.</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {[{ n: "2016", l: "Serving since" }, { n: "Pan-India", l: "Coverage" }, { n: "1 day", l: "Quote turnaround" }, { n: "100%", l: "Itemised quotes" }].map((s, i) => (
            <Reveal key={s.l} delay={i * 70}>
              <div className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-8 text-center">
                <div className="font-display text-4xl font-semibold text-[#2A1808]">{s.n}</div>
                <div className="mt-1 text-sm text-[#8A6B47]">{s.l}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="rounded-md bg-[#553204] text-[#F9EFE1] p-10 lg:p-14 text-center">
          <h2 className="font-display text-3xl sm:text-4xl text-white">"Vacanza Go sells memories and lifetime experiences — not commodity packages."</h2>
          <p className="mt-4 text-[#F9EFE1]/70">Our promise: you don't have to worry about anything once we take over.</p>
        </Reveal>
      </div>
    </div>
  );
}
